// src/components/filter/TagFilter.jsx

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFilter } from '../../redux/actions/filterActions';

const TagFilter = () => {
  const dispatch = useDispatch();
  const { loading: optionsLoading, data: filterOptions = {}, error: optionsError } =
    useSelector(state => state.filterOptions) || {};
  const chosenFilters = useSelector(state => state.filters) || {};
  const tags = filterOptions.tags || [];

  if (optionsError) return <p>Error loading tags: {optionsError}</p>;
  if (optionsLoading) return <p>Loading tags…</p>;

  return (
    <div className="my-4">
      <h6 className="font-semibold lg:text-lg mb-2">Tags</h6>
      <div className="flex flex-wrap gap-2">
        {tags.map(tagObj => {
          const name = tagObj.tag_name;
          return (
            <button
              key={name}
              onClick={() => {
                const updated = chosenFilters.tags.includes(name)
                  ? chosenFilters.tags.filter(t => t !== name)
                  : [...chosenFilters.tags, name];
                dispatch(setFilter('tags', updated));
              }}
              className={`px-3 py-1 rounded border ${
                chosenFilters.tags.includes(name)
                  ? 'bg-medium-theme-color text-white'
                  : 'bg-white text-black border-black'
              }`}
            >
              {name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TagFilter;

